<template>
  <v-container>
    <v-row
      justify="end"
      align-content="end"
    >
      <v-col>
        <v-btn
          rounded
          dense
          small
          class="float-right"
          color="primary"
          @click="handleAddNewFlow()"
          :disabled="!canUserEdit"
        >
          <v-icon> mdi-plus </v-icon>
          {{ $t('workflow.add') }}
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-expansion-panels v-model="panels">
        <v-expansion-panel
          v-for="(flow, flowIndex) in workflows"
          :key="`flow-${flowIndex}`"
        >
          <v-expansion-panel-header>
            <v-row>
              <v-col>
                <span class="blue--text">{{flow.isTemplate ? $t('workflow.template') : ''}} </span>
                <span class="pa-2">{{flow.cardTitle}}</span>
              </v-col>
            </v-row>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <SingleWorkflow
              :flow="flow"
              @delete="handleDeleteFlow(flow, flowIndex)"
              @update="newFlow => handleFlowUpdate(newFlow, flowIndex)"
              @copy-template="handleAddNewFlow({ ...flow, name: `${flow.name} ${workflows.length}` })"
              :can-user-edit="canUserEdit"
            />
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-row>
  </v-container>
</template>

<script>
import { EMPTY_WORKFLOW } from '@/helpers'
import { deleteFlow, addFlow, updateFlow } from '@/services'
import { mapState } from 'vuex'

export default {
  name: 'WorkflowsPanels',
  props: {
    type: String,
    workflows: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      panels: null
    }
  },
  computed: {
    ...mapState({
      canUserEdit: state => state.userPermissionsToContract.canUserEdit
    })
  },
  methods: {
    async handleFlowUpdate (newFlow) {
      await updateFlow(this.type, newFlow, this.$route.params.contractId)
      this.$emit('update-workflows')
    },
    async handleDeleteFlow (flow, index) {
      this.$eventBus.$emit('OPEN_CONFIRM_MODAL', {
        scope: {
          message: this.$t('common.deleteConfirm', { name: flow.name })
        },
        handlers: {
          yes: async () => {
            flow.id && await deleteFlow(this.type, flow, this.$route.params.contractId)
            this.$emit('update-workflows')
            this.panels = index > 0 ? index - 1 : 0
          }
        }
      })
    },
    async handleAddNewFlow (flow) {
      await addFlow(this.type, flow || EMPTY_WORKFLOW, this.$route.params.contractId)
      this.$emit('update-workflows')
      this.panels = this.workflows.length
    }
  }
}
</script>
